<template>
  <div class="language-switch">
    <img 
      :src="currentLocale === 'zh' ? require('../../assets/common/header/chinese_english_chi.png') : require('../../assets/common/header/chinese_english_eng.png')"
      :alt="currentLocale === 'zh' ? '切换到英文' : 'Switch to Chinese'"
      @click="toggleLanguage"
      class="lang-icon"
    >
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'LanguageSwitch',
  setup() {
    const { locale } = useI18n()

    const toggleLanguage = () => {
      const newLocale = locale.value === 'zh' ? 'en' : 'zh'
      locale.value = newLocale
      localStorage.setItem('locale', newLocale)
    }

    return {
      currentLocale: locale,
      toggleLanguage
    }
  }
}
</script>

<style scoped>
.language-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.lang-icon {
  width: clamp(20px, 2.5vw, 24px);
  height: clamp(20px, 2.5vw, 24px);
  cursor: pointer;
  transition: all 0.3s;
  padding: 2px;
  border-radius: 4px;
  /* background: rgba(0,0,0,0.05); */
}

.lang-icon:hover {
  transform: scale(1.1);
  background: rgba(0,0,0,0.1);
}

/* 大屏幕设备 */
@media screen and (min-width: 1400px) {
  .lang-icon {
    width: 30px;
    height: 30px;
    padding: 3px;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .lang-icon {
    width: 27px;
    height: 27px;
    padding: 2.5px;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .lang-icon {
    width: 24px;
    height: 24px;
    padding: 2px;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .lang-icon {
    width: 22px;
    height: 22px;
    padding: 1.5px;
  }
}

/* 小屏手机 */
@media screen and (max-width: 479px) {
  .lang-icon {
    width: 20px;
    height: 20px;
    padding: 1px;
  }
}
</style> 